export default __webpack_public_path__ + "static/winter44-a9ac7706b6b565968885f4d495e6ef18.webp";